import React, { FC } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './useAuth'

export const RequireAuth: FC = ({ children }) => {
  const { isSignedIn } = useAuth()
  const location = useLocation()

  if (!isSignedIn) {
    return <Navigate to='/sign-in' replace state={{ from: location }} />
  }

  return <>{children}</>
}
